export enum ActionTypeChoices {
  NOVA = 'Nova',
  CONFORMANCE = 'Conformance',
  QUALITY = 'Quality',
  NO_ACTION = 'No Action',
}
